





import { Component, Vue, Model, Emit } from 'vue-property-decorator'

@Component({
  components: {}
})
export default class Home extends Vue {}
